export enum SettingsSidebarId {
  EDIT_PROFILE,
  ACCOUNT,
  NOTIFICATIONS,
  BILLING,
  DEACTIVATION
}

export const SettingsItemList = [
  {id: SettingsSidebarId.EDIT_PROFILE, label: 'Edit profile'},
  {id: SettingsSidebarId.ACCOUNT, label: 'Account'},
  {id: SettingsSidebarId.NOTIFICATIONS, label: 'Notifications'},
  {id: SettingsSidebarId.BILLING, label: 'Billing'},
  {id: SettingsSidebarId.DEACTIVATION, label: 'Deactivation'},
]